import { render, staticRenderFns } from "./VersionFooter.vue?vue&type=template&id=7cace900"
import script from "./VersionFooter.vue?vue&type=script&lang=ts"
export * from "./VersionFooter.vue?vue&type=script&lang=ts"
import style0 from "./VersionFooter.vue?vue&type=style&index=0&id=7cace900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports